import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../mock';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const [direction, setDirection] = useState('ltr');

  useEffect(() => {
    if (language === 'ar') {
      setDirection('rtl');
      document.documentElement.setAttribute('dir', 'rtl');
    } else {
      setDirection('ltr');
      document.documentElement.setAttribute('dir', 'ltr');
    }
  }, [language]);

  const t = translations[language];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, direction }}>
      {children}
    </LanguageContext.Provider>
  );
};